import React ,{ PropTypes } from 'react';
import {Link} from 'react-router-dom';
//import HomeForm from './HomeForm';
import Slider from 'react-slick';
import { FormattedMessage } from 'react-intl';

class RestaurantHome extends React.Component{
   static propTypes = {
    categories: PropTypes.array,
    city: PropTypes.string,
    country: PropTypes.string,
    history: PropTypes.object,
    intro_options: PropTypes.array,
    match: PropTypes.object,
    name: PropTypes.string,
    package: PropTypes.number,
    slug: PropTypes.string,
    view_info: PropTypes.func,
    logo: PropTypes.string,
    simpleTheme: PropTypes.bool,
    wineSlug: PropTypes.string,
    backgroundImage: PropTypes.string,
    button1Title: PropTypes.string,
    button1Link: PropTypes.string,
    button2Title: PropTypes.string,
    button2Link: PropTypes.string,
    button3Title: PropTypes.string,
    button3Link: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.settings = {
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      draggable: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false

          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: false
          }
        }
      ]
    };

  }

  componentDidMount() {
    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info('', "home",false, '');
  }

  render() {
    // Slick slider settings
    let listImages = {};

    if(this.props.categories && this.props.categories.length !== 0) {
      // FOUND THE RESULTS, MAPPING THEM HERE AND RENDERING FURTHER BELOW
      listImages = this.props.categories.map((item) => {
        let url = '/' + this.props.match.params.lang + '/' + this.props.slug + '/items/' + item.slug + '-' + item.id;
        if(item.template === 'wine'){
          url = '/' + this.props.match.params.lang + '/' + this.props.slug + '/wine/' + item.slug + '-' + item.id;
        }
        return (
          <Link key={'categories-' + item.id} to={url}>
            <div className="caption">
              <h1>{item.name}</h1>
            </div>
            <img src={item.photo} alt={item.name}/>
          </Link>
        );
      });
    }

    return (
      <div className="home">
        <div className="home-wrapper" style={this.props.simpleTheme ? {background: `url(${this.props.backgroundImage}) no-repeat center`, boxShadow: `inset 0 0 0 2000px rgba(0, 0, 0, 0.3)`,  backgroundSize: 'cover'} :null}>
           {!this.props.simpleTheme && this.props.categories && this.props.categories.length !== 0 ?
            <div className="slider-container category-slider">
              <Slider {...this.settings}>
                {listImages}
              </Slider>
            </div>
            : null
          } 
          <div  className={this.props.simpleTheme ?"start-simple" : "start"}>
            <img src={this.props.logo} />
            <h1>{this.props.name}</h1>
            <span className="location">{this.props.city}, {this.props.country}</span>
            {/* {this.props.package === 1?
              (<HomeForm introOptions={this.props.intro_options}
              restaurant={this.props.slug} lang={this.props.match.params.lang} history={this.props.history}/>):null
            } */}
          </div>
          {this.props.simpleTheme ? 
            <div className="start-buttons">
            {
              this.props.button1Link?
              <a className="primary-home-btn home-btn btn"
              href={this.props.button1Link}>
                {
                this.props.button1Title ||  
                <FormattedMessage id="nav_menu">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              
             </a>:
              <Link className="primary-home-btn home-btn btn"
              to={'/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/menu'}>
              {
                this.props.button1Title ||  
                <FormattedMessage id="nav_menu">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              </Link>
            }
            
            {
              this.props.button2Link?
              <a className="secondary-home-btn home-btn btn"
              href={this.props.button2Link}>
                {
                this.props.button2Title ||  
                <FormattedMessage id="nav_wines">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              
             </a>:
              <Link className="secondary-home-btn home-btn btn"
              to={'/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + this.props.wineSlug}>
              {
                this.props.button2Title ||  
                <FormattedMessage id="nav_wines">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              </Link>
            }
           
           {
              this.props.button3Link?
              <a className="tertiary-home-btn home-btn btn"
              href={this.props.button3Link}>
                {
                this.props.button3Title ||  
                <FormattedMessage id="nav_suggestions">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              
             </a>:
              <Link className="tertiary-home-btn home-btn btn"
              to={'/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/items/featured/'}>
              {
                this.props.button3Title ||  
                <FormattedMessage id="nav_suggestions">
                 {(message) => <span>{message}</span>}
                 </FormattedMessage>
                }
              </Link>
            }

            </div> : null
          }
          
        </div>
      </div>
    );
  }
}

export default RestaurantHome;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/RestaurantHome.js
 **/